export const getUserInitials = user => {
  if (!user || !user.first_name || !user.last_name) {
    return '';
  }
  return `${user.first_name?.charAt(0)}${user.last_name?.charAt(
    0,
  )}`.toUpperCase();
};
